/* eslint-disable max-statements */
import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep, isEmpty } from "lodash";
import { DatapointIdStandardEnum } from "api/ux/src";
import { InspectDataTab } from "components/modal/widget-inspect-data/types";
import { WidgetMode } from "store/current-dashboard/types";
export const initialState = { inspectDataTab: InspectDataTab.FullHistory,
    widgets: { ActualsAndProjections: { componentName: "InsDatapointGridWidget",
            componentProps: { datapointParams: [{}],
                pipelineParameter: { compositeObjectBuilder: { options: {
                            getMeasuresAndDimensionsFromDatapointParams: true
                        } },
                    nodesVisitorsReducer: [{ method: "addReferenceDateVisitor" }] } } },
        Asset: { componentName: "InsDatapointGridWidget",
            componentProps: { datapointParams: [{}],
                pipelineParameter: { compositeObjectBuilder: { options: {
                            getMeasuresAndDimensionsFromDatapointParams: true
                        } },
                    nodesVisitorsReducer: [{ method: "addReferenceDateVisitor" }] } } },
        Cashflows: { componentName: "InsDatapointGridWidget",
            componentProps: { datapointParams: [{}],
                pipelineParameter: { compositeObjectBuilder: { options: {
                            getMeasuresAndDimensionsFromDatapointParams: true
                        } },
                    nodesVisitorsReducer: [{ method: "addReferenceDateVisitor" }] } } },
        CommitmentPacingOutputs: { componentName: "InsDatapointGridWidget",
            componentProps: { datapointParams: [{}],
                pipelineParameter: { compositeObjectBuilder: { options: {
                            getMeasuresAndDimensionsFromDatapointParams: true
                        } },
                    nodesVisitorsReducer: [{ method: "addReferenceDateVisitor" }] } } },
        ComparisonPortfolio: { componentName: "InsDatapointGridWidget",
            componentProps: { datapointParams: [],
                pipelineParameter: { compositeObjectBuilder: { options: {
                            getMeasuresAndDimensionsFromDatapointParams: true
                        } },
                    nodesVisitorsReducer: [{ method: "addReferenceDateVisitor" }] } } },
        FullHistory: { componentName: "InsDatapointGridWidget",
            componentProps: { datapointParams: [{}],
                pipelineParameter: { compositeObjectBuilder: { options: {
                            getMeasuresAndDimensionsFromDatapointParams: true
                        } },
                    nodesVisitorsReducer: [{ method: "addReferenceDateVisitor" }] } } },
        Fund: { componentName: "InsDatapointGridWidget",
            componentProps: { datapointParams: [{}],
                pipelineParameter: { compositeObjectBuilder: { options: {
                            getMeasuresAndDimensionsFromDatapointParams: true
                        } },
                    nodesVisitorsReducer: [{ method: "addReferenceDateVisitor" }] } } },
        Portfolio: { componentName: "InsDatapointGridWidget",
            componentProps: { datapointParams: [],
                pipelineParameter: { compositeObjectBuilder: { options: {
                            getMeasuresAndDimensionsFromDatapointParams: true
                        } },
                    nodesVisitorsReducer: [{ method: "addReferenceDateVisitor" }] } } } } };
const updateComponentProps = (state, action, level, newParams, mode) => {
    state.widgets[level].componentProps = {
        ...state.widgets[level].componentProps,
        columnsTemplate: { columns: action.payload.columnDefs[level] },
        datapointParams: newParams,
        filterCashflows: action.payload.filterCashflows,
        mode,
        periodOfAnalysisParams: newParams.length > 0 ? newParams[0]?.periodOfAnalysisParams : [],
        tenor: action.payload.tenor
    };
};
const handlePortfolioLevel = (state, action, newParams) => {
    const copy = cloneDeep(newParams);
    const index = copy[0].measures.findIndex((x) => x.standardDatapoint === DatapointIdStandardEnum.PortfolioPortfolioName);
    copy[0].measures.push({
        name: "PortfolioName",
        standardDatapoint: DatapointIdStandardEnum.PortfolioPortfolioName
    });
    if (index !== -1) {
        copy[0].measures.splice(index, 1);
    }
    state.widgets.Portfolio.componentProps = {
        ...state.widgets[InspectDataTab.Portfolio].componentProps,
        columnsTemplate: { columns: action.payload.columnDefs[InspectDataTab.Portfolio] },
        datapointParams: copy,
        filterCashflows: action.payload.filterCashflows,
        mode: WidgetMode.Comparison,
        periodOfAnalysisParams: copy[0].periodOfAnalysisParams,
        tenor: action.payload.tenor
    };
};
const handleComparisonLevel = (state, action, level, newParams) => {
    const copy = cloneDeep(newParams);
    state.widgets.ComparisonPortfolio.componentProps = {
        ...state.widgets[level].componentProps,
        columnsTemplate: { columns: action.payload.columnDefs[level] },
        datapointParams: copy,
        mode: WidgetMode.Comparison,
        periodOfAnalysisParams: copy[0].periodOfAnalysisParams,
        tenor: action.payload.tenor
    };
    state.widgets[level].componentProps = {
        ...initialState.widgets[level].componentProps,
        datapointParams: [],
        periodOfAnalysisParams: copy[0].periodOfAnalysisParams
    };
};
const slice = createSlice({
    initialState,
    name: "inspectDataReducers",
    reducers: {
        createInspectDataWidget: (state, action) => {
            Object.values(InspectDataTab).forEach((level) => {
                const newParams = action.payload.params[level];
                if (action.payload.params[level][0]?.measures &&
                    !action.payload.params[level][0]?.measures.every((d) => d.periods === action.payload.params[level][0].measures[0].periods)) {
                    newParams[0].measures = newParams[0].measures.map((d) => ({
                        ...d,
                        periods: 1
                    }));
                }
                if (level === InspectDataTab.Portfolio && newParams.length > 0) {
                    handlePortfolioLevel(state, action, newParams);
                    return;
                }
                if ((level === InspectDataTab.Fund || level === InspectDataTab.Asset) &&
                    action.payload.isComparisonWidget &&
                    newParams.length > 0) {
                    handleComparisonLevel(state, action, level, newParams);
                    return;
                }
                const mode = action.payload.isComparisonWidget ? WidgetMode.Comparison : WidgetMode.Normal;
                updateComponentProps(state, action, level, newParams, mode);
            });
            if (action.payload.isComparisonWidget) {
                state.inspectDataTab = InspectDataTab.Portfolio;
            }
            else if (!isEmpty(action.payload.columnDefs.Fund)) {
                state.inspectDataTab = InspectDataTab.Fund;
            }
            else if (!isEmpty(action.payload.columnDefs.Asset)) {
                state.inspectDataTab = InspectDataTab.Asset;
            }
            else if (!isEmpty(action.payload.columnDefs.Cashflows)) {
                state.inspectDataTab = InspectDataTab.Cashflows;
            }
        },
        removeInspectDataWidget: (state) => {
            state.widgets = initialState.widgets;
            state.inspectDataTab = initialState.inspectDataTab;
        },
        setInspectDataSelectedTab: (state, action) => {
            state.inspectDataTab = action.payload;
        }
    }
});
export const inspectDataReducers = slice.reducer;
export const { createInspectDataWidget, removeInspectDataWidget, setInspectDataSelectedTab } = slice.actions;
